import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export function ModelFileViewerPage() {
  const { modelId, fileId } = useParams<{ modelId: string; fileId: string }>();
  const navigate = useNavigate();

  // Temporary redirect: 3D Viewer under development, redirect to file details page
  useEffect(() => {
    if (modelId && fileId) {
      navigate(`/models/${modelId}/files/${fileId}/details`, { replace: true });
    }
  }, [modelId, fileId, navigate]);

  // Show loading state while redirect happens
  return (
    <div className="flex h-screen items-center justify-center bg-background">
      <div className="text-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent mx-auto mb-4" />
        <p className="text-foreground-muted">Redirecting...</p>
      </div>
    </div>
  );
}
